document.addEventListener('DOMContentLoaded', function() {
    const collectionCarousels = document.querySelectorAll('.collection-carousel');
    collectionCarousels.forEach(function(collectionCarousel) {
        let targetWrapper = collectionCarousel.querySelector('.collection-carousel__collections');
        const swiper = new Swiper(targetWrapper, {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 2.4,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: false,
                },
                1024: {
                    slidesPerView: 3.2,
                    spaceBetween: 25,
                    pagination: false,
                },
            }
        });
        const prevButton = collectionCarousel.querySelector('.custom-swiper-prev');
        const nextButton = collectionCarousel.querySelector('.custom-swiper-next');
        prevButton.addEventListener('click', function() {
            swiper.slidePrev();
        });
        nextButton.addEventListener('click', function() {
            swiper.slideNext();
        });
    });
});